import { useEffect, useRef, useState } from "react";

const reviews = [
  {
    text: "My son begs for the Missing Mango story every night! He learned what 'honesty' means and now uses the word all the time. These books are pure magic.",
    name: "Sarah M.",
    role: "Mom of 2",
  },
  {
    text: "Finally, children's books that are fun AND teach something. The Splash Too Far story helped my son understand listening. The capybara friends are adorable.",
    name: "James T.",
    role: "Dad of 3",
  },
  {
    text: "My kids fight over who gets to be Cappy and who gets to be Barry at storytime. The Wobbly Bridge story made my 4-year-old cry happy tears. We love this series!",
    name: "Emily R.",
    role: "Mom of 4 & 6",
  },
  {
    text: "Bought the whole set for my nephew's birthday. The illustrations are gorgeous and the messages are just subtle enough that kids don't feel lectured. Highly recommend!",
    name: "Michelle L.",
    role: "Mom of 5",
  },
  {
    text: "As a dad of twins, the 'Big Muddy Mess' story hit home hard. The twins actually reference Cappy and Barry when we remind them about saying sorry. These books really stick!",
    name: "David K.",
    role: "Dad of twins",
  },
  {
    text: "The Grumpy Goose book is a game-changer for bedtime. My daughter actually settles down faster now. Barry being 'calm and wise' gives her a role model to look up to.",
    name: "Anna B.",
    role: "Mom of 3",
  },
];

export default function ReviewsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="reviews"
      className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50 overflow-hidden"
    >
      <div
        ref={ref}
        className={`w-full transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-semibold rounded-full mb-4">
            Parent Reviews
          </span>
          <h2 className="font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            What Parents Are Saying
          </h2>
          <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
            Real stories from real families who have welcomed Cappy and Barry
            into their bedtime routines.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-6 md:p-8 border border-background-200 shadow-lg shadow-foreground-950/10 hover:shadow-xl hover:shadow-foreground-950/15 transition-all duration-500 hover:-translate-y-1 ${
                visible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-500 text-sm" />
                ))}
              </div>
              <div className="relative mb-5">
                <i className="ri-double-quotes-l text-primary-300/40 text-3xl absolute -top-2 -left-1" />
                <p className="text-foreground-700 text-base leading-relaxed relative z-10 pl-4">
                  {review.text}
                </p>
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-smile-line text-primary-500 text-lg" />
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">
                    {review.name}
                  </p>
                  <p className="text-foreground-400 text-xs">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}